import { CallHeader } from "@beydesign/storybook"
import React from "react"
import { useBranding } from "../hooks"
import { safeHttpUrl } from "../utils/branding"

const createAgentUrl = "https://bey.studio/agents/create"

export function Header() {
  const branding = useBranding()

  const handleCreateOwnAgent = () => {
    window.open(createAgentUrl, "_blank", "noopener")
  }

  const handleLogoClick = () => {
    if (branding) {
      const href = safeHttpUrl(branding.brand_website) || "/"
      window.open(href, "_blank", "noopener")
    } else {
      window.location.href = "/"
    }
  }

  return (
    <CallHeader
      logoUrl={branding?.logo_url ?? null}
      logoColor={
        !branding ? "var(--color-foreground-fg-brand-logo)" : undefined
      }
      onLogoClick={handleLogoClick}
      showAction={!branding}
      onActionClick={handleCreateOwnAgent}
      actionId="call-header-create-agent"
      sx={{
        paddingX: "var(--call-shell-gutter)",
        backgroundColor: "transparent",
      }}
    />
  )
}
